<div class="content">
  <div class="title">{{ importColleaguesDialog.title }}</div>
  <div class="colleagues-box">
    @if (colleaguesList) {
    <div class="colleagues_list">
      @if (colleaguesList.length > 0) {
      <div>Select one or more existing colleagues that you have already created to add them to this company.</div>
      @for (colleague of colleaguesList; track colleague) {
      <div class="colleague-row-item">
        <div class="checkbox-container">
          <input type="checkbox" [ngModel]="colleague.active" (click)="colleagueActiveChanged(colleague.email)" />
          <span class="checkmark"></span>
        </div>
        <span class="checkmark-label">{{ colleague.firstName }} {{ colleague.lastName }}, {{ colleague.email }}</span>
      </div>
      } } @if (colleaguesList.length === 0) {
      <div>There are no colleagues to import.</div>
      }
    </div>
    } @else {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>
  @if (colleaguesList) {
  <div class="actions">
    <button class="ddd-button" (click)="dialogRef.close(false)">
      {{ importColleaguesDialog.cancel }}
    </button>
    @if (colleaguesList.length > 0) {
    <button class="ddd-button raised" (click)="importColleagues()">
      {{ importColleaguesDialog.okBtn }}
    </button>
    }
  </div>
  }
</div>
